<template>
  <component
    :is="getComponentByType"

    ref="control"

    :disabled="disabled"

    :value="valuePrepared"
    @input="$emit( 'input', $event )"

    :refs="refs"
    :misc="misc"

    @ok="$emit( 'ok', $event )"
    @error="$emit( 'error', $event )"
    v-bind="getPropsByType"
  />
</template>

<script>
import DVfieldBoolean from "./DVfieldBoolean";
import DVfieldString from "./DVfieldString";
import DVfieldDate from "./DVfieldDate";
import DVfieldDatetime from "./DVfieldDatetime";
import DVfieldReference from "./DVfieldReference";

const Types = {
  "reference":    "DVfieldReference",

  "xsd:boolean":  "DVfieldBoolean",
  "xsd:date":     "DVfieldDate",
  "xsd:dateTime": "DVfieldDatetime",
  "xsd:datetime": "DVfieldDatetime",
  "xsd:string":   "DVfieldString",

	"http://www.w3.org/2001/XMLSchema#boolean": "DVfieldBoolean",
	"http://www.w3.org/2001/XMLSchema#date":    "DVfieldDate",
	"http://www.w3.org/2001/XMLSchema#dateTime":"DVfieldDatetime",
	"http://www.w3.org/2001/XMLSchema#datetime":"DVfieldDatetime",
	"http://www.w3.org/2001/XMLSchema#string":  "DVfieldString",
};

export default {
	name:  "DVfield",

  components: {
    DVfieldBoolean,
    DVfieldString,
    DVfieldDate,
    DVfieldDatetime,
    DVfieldReference
  },

	props: {
		type:    {
			type:   String,
			default:"xsd:string",
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
		value:  {
		},
    refs: {
		  type: Array,
      default: () => []
    },
    misc: {
		  type: Object,
      default: () => null
    }
	},
	data() {
		return {
		};
	},
	mounted() {
	},
  computed: {
	  valuePrepared() {
	    if ( this.getComponentByType == "DVfieldReference" ) {
	      if ( this.value && ( "id" in this.value ) && ( "name" in this.value ) ) return this.value;
	      return { id: null, name: null };
      }

	    return "" + this.value;
    },

	  getComponentByType() {
	    if ( this.type in Types ) return Types[ this.type ];
	    return Types["xsd:string"];
    },

    getPropsByType() {
	    const props = {};

	    if ( this.type == "xsd:string" || this.type == "http://www.w3.org/2001/XMLSchema#string" ) props.multiline = true;

      return props;
    }
  },
	methods: {
	  update( ...args ) {
	    if ( this.$refs && this.$refs.control && this.$refs.control.update ) this.$refs.control.update( ...args );
    }
	}
};
</script>

<style scoped>
</style>